export const eventTypes = {
    "CARRUSEL":"carousel",
    "BANNER":"popup",
    "CINTILLO":"headband",
    "BANNER APP":"popup_app",
    "CINTILLO APP":"headband_app",
}